import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import TransportOrder from '../components/addEditCopy/index.vue';

var AddTransportOrderPage = function (_super) {
  __extends(AddTransportOrderPage, _super);

  function AddTransportOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddTransportOrderPage = __decorate([Component({
    components: {
      TransportOrder: TransportOrder
    }
  })], AddTransportOrderPage);
  return AddTransportOrderPage;
}(Vue);

export default AddTransportOrderPage;